import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AppUser } from '@classes/auth/infosUser';
import { Camera } from '@classes/camera/camera';
import { CameraWaste } from '@classes/waste-camera/waste-camera';
import { DataService } from '@services/data/data.service';
import { CameraWasteService } from '@services/cameraWaste/CameraWasteService';
import { faCogs, faInfoCircle, faPen, faRedo } from '@fortawesome/free-solid-svg-icons';
import { CameraOptionComponent } from '../camera-option/camera-option.component';
import { SmartparkingCameraInfosLastSyncComponent } from 'app/components/smartparking/smartparking-camera-infos-last-sync/smartparking-camera-infos-last-sync.component';

@Component({
  selector: 'app-app-camera-waste-table',
  templateUrl: './app-camera-waste-table.component.html',
  styleUrls: ['./app-camera-waste-table.component.scss']
})
export class AppCameraWasteTableComponent implements OnInit {


  faPen = faPen;
  faRedo = faRedo;
  faInfoCircle = faInfoCircle;
  faCogs = faCogs;
  displayedColumns: string[] = ['camera', 'application', 'lastSync', 'batterie', 'Reset', 'onOff', 'option'];
  dataSource: MatTableDataSource<CameraWaste>;


  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';
  isAdmin: boolean;
  cameraWaste: CameraWaste[];

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  show = false;
  userAppSelected: AppUser;


  constructor(
    private dialog: MatDialog,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    public router: Router,
    private CameraWasteService: CameraWasteService,
  ) {

  }

  ngOnInit(): void {

    this.getCameraWaste();

  }




  applyFilter(filterValue): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }



  showElement(): void {
    setTimeout(() => {
      this.show = true;
    }, 150);
  }

  openDialogOptionCamera(): void {
    const dialogRef = this.dialog.open(CameraOptionComponent, {

    });
  }

  openDialogInfoCamera(infos: Camera): void {
    const dialogRef = this.dialog.open(SmartparkingCameraInfosLastSyncComponent, {
      data: { lastSync: infos }
    });

  }


  private getCameraWaste(): void {

    this.cameraWaste = this.CameraWasteService.waste;
    this.dataSource = new MatTableDataSource<CameraWaste>(this.cameraWaste);
  };
}

